import React from 'react';
import styles from './SpecificationsSection.module.css';

const SpecificationsSection = ({
  titleLead = 'Product',
  titleAccent = 'Specifications',
  specs = {
    businessType: {
      label: "Business Type",
      value: "Manufacturer, Exporter, Supplier, Retailer, Wholesaler",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
          <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
        </svg>
      )
    },
    location: {
      label: "Buyer Preferred Location",
      value: "Pan India Supply + Export",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
      )
    },
    type: {
      label: "Type",
      value: "PE Coated Paper",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
          <polyline points="14 2 14 8 20 8" />
          <line x1="16" y1="13" x2="8" y2="13" />
          <line x1="16" y1="17" x2="8" y2="17" />
          <polyline points="10 9 9 9 8 9" />
        </svg>
      )
    },
    color: {
      label: "Color",
      value: "White / Natural Kraft",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" />
          <path d="M7.5 10.5C8.32843 10.5 9 9.82843 9 9C9 8.17157 8.32843 7.5 7.5 7.5C6.67157 7.5 6 8.17157 6 9C6 9.82843 6.67157 10.5 7.5 10.5Z" />
          <path d="M11.5 7.5C12.3284 7.5 13 6.82843 13 6C13 5.17157 12.3284 4.5 11.5 4.5C10.6716 4.5 10 5.17157 10 6C10 6.82843 10.6716 7.5 11.5 7.5Z" />
          <path d="M16.5 10.5C17.3284 10.5 18 9.82843 18 9C18 8.17157 17.3284 7.5 16.5 7.5C15.6716 7.5 15 8.17157 15 9C15 9.82843 15.6716 10.5 16.5 10.5Z" />
          <path d="M6 14C6 14 7.5 19 12 19C16.5 19 18 14 18 14" />
        </svg>
      )
    },
    coating: {
      label: "Coating",
      value: "PE Coated Food Grade",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2L2 7l10 5 10-5-10-5z" />
          <path d="M2 17l10 5 10-5" />
          <path d="M2 12l10 5 10-5" />
        </svg>
      )
    },
    material: {
      label: "Material",
      value: "Pure Virgin Wood Pulp",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z" />
        </svg>
      )
    },
    gsm: {
      label: "GSM",
      value: "140 - 320 GSM",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 7V4h16v3" />
          <path d="M9 20h6" />
          <path d="M12 4v16" />
        </svg>
      )
    },
    usage: {
      label: "Usage",
      value: "Burgers, Sandwiches, Bakery & Wraps",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 2L2 7l10 5 10-5-10-5Z" />
          <path d="M2 17l10 5 10-5" />
          <path d="M2 12l10 5 10-5" />
        </svg>
      )
    },
    thickness: {
      label: "Thickness",
      value: "As per requirement",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <circle cx="12" cy="12" r="6" />
          <circle cx="12" cy="12" r="2" />
        </svg>
      )
    },
    feature: {
      label: "Feature",
      value: "Greaseproof, Heat Resistant, Moisture Proof, Waterproof",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        </svg>
      )
    },
    industrialUse: {
      label: "Industrial Use",
      value: "Cup Making & Punching",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="2" width="20" height="8" rx="2" />
          <rect x="2" y="14" width="20" height="8" rx="2" />
          <line x1="6" y1="10" x2="6" y2="14" />
          <line x1="18" y1="10" x2="18" y2="14" />
        </svg>
      )
    },
    sizes: {
      label: "Sizes",
      value: "As per requirement",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="21 8 21 21 8 21" />
          <rect x="3" y="3" width="14" height="14" rx="2" ry="2" />
        </svg>
      )
    }
  }
}) => {
  // Specs Object keys splitting into two clean parts for multi-column symmetry
  const specKeys = Object.keys(specs);
  const halfLength = Math.ceil(specKeys.length / 2);
  const leftColSpecs = specKeys.slice(0, halfLength);
  const rightColSpecs = specKeys.slice(halfLength);

  return (
    <section className={styles.specsSection} aria-labelledby="product-specs-heading">
      <div className={styles.bgDecor} aria-hidden="true">
        <div className={styles.topGlow} />
        <div className={styles.meshGrid} />
        <span className={styles.watermark}>GREENERI</span>
        <div className={styles.orbGreen} />
        <div className={styles.orbOrange} />
        <div className={styles.topAccentLine} />
      </div>

      <div className={styles.container}>
        <div className={styles.sectionHeader}>
          <h2 id="product-specs-heading" className={styles.mainTitle}>
            {titleLead}{' '}
            <span className={styles.titleAccent}>{titleAccent}</span>
          </h2>
          <div className={styles.accentLine} />
        </div>

        <div className={styles.specsPanel}>
          <div className={styles.specsSplitDeck}>
          
          {/* Left Spec Track Column */}
          <div className={styles.specTrack}>
            {leftColSpecs.map((key) => {
              const item = specs[key];
              return (
                <div key={key} className={styles.specRow}>
                  <div className={styles.orangeHoverBar}></div>
                  <div className={styles.rowLabelGroup}>
                    <div className={styles.iconFrame}>{item.icon}</div>
                    <span className={styles.labelName}>{item.label}</span>
                  </div>
                  <div className={styles.rowValue}>{item.value}</div>
                </div>
              );
            })}
          </div>

          {/* Right Spec Track Column */}
          <div className={styles.specTrack}>
            {rightColSpecs.map((key) => {
              const item = specs[key];
              return (
                <div key={key} className={styles.specRow}>
                  <div className={styles.orangeHoverBar}></div>
                  <div className={styles.rowLabelGroup}>
                    <div className={styles.iconFrame}>{item.icon}</div>
                    <span className={styles.labelName}>{item.label}</span>
                  </div>
                  <div className={styles.rowValue}>{item.value}</div>
                </div>
              );
            })}
          </div>

          </div>
        </div>
      </div>
    </section>
  );
};

export default SpecificationsSection;